<template>
  <v-dialog v-model="showModal" persistent max-width="800" :overlay="true">
    <v-card>
      <v-toolbar tabs>
        <v-toolbar-title id="title">Import Workflow</v-toolbar-title>
      </v-toolbar>
      <v-layout class="my-3">
        <v-spacer></v-spacer>
        <input type="file" accept=".zip" multiple=false ref="input">
        <v-spacer></v-spacer>
      </v-layout>
      <v-layout>
        <v-spacer></v-spacer>
        <v-btn color="info" :loading="loading" :disabled="loading" @click.native="importFile">
          Import
          <v-icon right>cloud_upload</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
      </v-layout>
      <v-toolbar tabs>
        <v-spacer></v-spacer>
        <v-btn class="black--text" flat @click.native="$emit('hide-modal')">Close</v-btn>
      </v-toolbar>
    </v-card>
  </v-dialog>
</template>

<script>
import JSZip from 'jszip'
export default {
  data: () => ({
    loading: false
  }),
  methods: {
    importFile() {
      if(this.$refs.input.files.length>0) {
        this.loading = true;
        var file = this.$refs.input.files[0];
        var new_zip = new JSZip();
        var workflow;
        new_zip.loadAsync(file).then((result) => this.handleFile(result));
        this.loading = false;
        this.$emit('hide-modal');
      }
    },
    handleFile(f) {
      f.file('decspace.json').async('string').then((result) => this.handleJson(result));
    },
    handleJson(json) {
      var workflow = JSON.parse(json);
      this.$emit('import-workflow', workflow);
    }
  },
  props: {
    showModal: Boolean
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Workspace/Menus/ImportWorkflowModal.vue